import React from 'react';

import Banner from '../components/Banner';
import Footer from '../components/Footer';
import styles from './Page.module.css';

const CncSkill = () => {
    return (
        <div className='Page CncSkill'>
            <Banner title={`CNC Machining`} custom={true} />
            <section className={styles.section}>

            </section>
            <Footer></Footer>
        </div>
    );
};

export default CncSkill;